import React from 'react';
import { Link } from 'react-router-dom';
import { adminTheme } from './adminTheme';

type ActionLinkProps = {
  to: string;
  label: string;
  fullWidth?: boolean;
};

export default function ActionLink({
  to,
  label,
  fullWidth = true,
}: ActionLinkProps) {
  return (
    <Link
      to={to}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: adminTheme.space.md,
        width: fullWidth ? '100%' : 'auto',
        textDecoration: 'none',
        color: adminTheme.color.text,
        fontWeight: 700,
        fontSize: adminTheme.type.body,
        lineHeight: 1.2,
        padding: '12px 14px',
        borderRadius: adminTheme.radius.sm,
        background: adminTheme.color.surfaceMuted,
        border: `1px solid ${adminTheme.color.border}`,
        transition: adminTheme.transition.base,
      }}
    >
      <span>{label}</span>
      <span
        aria-hidden="true"
        style={{
          color: adminTheme.color.textMuted,
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        →
      </span>
    </Link>
  );
}